import React, { lazy, Suspense } from 'react';
import { RouteObject } from 'react-router-dom';
import { Spin } from 'antd';

const InvoiceListView = lazy(() => import('./views/InvoiceListView'));
const InvoiceCreateView = lazy(() => import('./views/InvoiceCreateView'));
const InvoiceDetailView = lazy(() => import('./views/InvoiceDetailView'));
const InvoiceEditView = lazy(() => import('./views/InvoiceEditView'));

const Loader = () => (
    <div className="flex justify-center p-8"><Spin size="large" /></div>
);

export const invoiceRoutes: RouteObject[] = [
    {
        path: '/invoices',
        element: <Suspense fallback={<Loader />}><InvoiceListView /></Suspense>
    },
    {
        path: '/invoices/new',
        element: <Suspense fallback={<Loader />}><InvoiceCreateView /></Suspense>
    },
    {
        path: '/invoices/:id',
        element: <Suspense fallback={<Loader />}><InvoiceDetailView /></Suspense>
    },
    {
        path: '/invoices/:id/edit',
        element: <Suspense fallback={<Loader />}><InvoiceEditView /></Suspense>
    }
];
